webpackJsonp([145206920446059],{

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/add-site.7270b324.png";

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hagley-road-line.906a15fa.png";

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hagley-road-map.a5956cbe.png";

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(40);
	
	var _hagleyRoadMap = __webpack_require__(458);
	
	var _hagleyRoadMap2 = _interopRequireDefault(_hagleyRoadMap);
	
	var _hagleyRoadLine = __webpack_require__(457);
	
	var _hagleyRoadLine2 = _interopRequireDefault(_hagleyRoadLine);
	
	var _addSite = __webpack_require__(456);
	
	var _addSite2 = _interopRequireDefault(_addSite);
	
	var _invite = __webpack_require__(459);
	
	var _invite2 = _interopRequireDefault(_invite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThePlatform = function ThePlatform() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactstrap.Container,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'mt-5' },
	        _react2.default.createElement(
	          'p',
	          { className: 'lead' },
	          'The Wintersense Platform comprises two key components:'
	        ),
	        _react2.default.createElement(
	          'ol',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'The back-end services responsible for data processing.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'The front-end ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://user.wintersense.com' },
	              'Web Application'
	            ),
	            ' for data visualisation and Network management.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'lead' },
	          'They work together to turn sensor data into reliable, actionable information.'
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'mt-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row align-items-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Inform decisions with real-time data'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-justify' },
	              'To see savings and improve saftey the data collected must inform and modify winter road maintanence operations.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The Wintersense platform does this in several ways:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Sensor data is clearly presented on the ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://user.wintersense.com' },
	                  'Web Application'
	                ),
	                ' using visualisations such as maps and line charts, providing insights into the current (or historical) state of your road network.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Visualisations update in real-time as soon as more data is received.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Wintersense recognises that every organisation has its own decision procedures and existing software systems. The Wintersense ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://docs.wintersense.com/api/v1' },
	                  'API'
	                ),
	                ' makes it easy to ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'pull'
	                ),
	                ' Wintersense data into your own systems.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The platform can even ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'push'
	                ),
	                ' data straight to you as soon as it arrives.'
	              )
	            ),
	            _react2.default.createElement(
	              'blockquote',
	              { className: 'blockquote' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'It\'s your data; you\'re free to use it how you like.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md' },
	            _react2.default.createElement('img', { src: _hagleyRoadMap2.default, className: 'img-fluid rounded', alt: 'Wintersense sensor' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'mt-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row align-items-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md order-md-2' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Manage as much or as little as you wish'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-justify' },
	              'The Wintersense team are on hand to setup and manage your sensor network. However, you\'re also free to configure and adjust your networks as you wish via the ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://user.wintersense.com' },
	                'Web Application'
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Here\'s what you can do:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Add new ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Sensors'
	                ),
	                ' to your ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Network'
	                ),
	                ', or remove existing ones.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Create, update or delete the list of ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Sites'
	                ),
	                '.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Sensors'
	                ),
	                ' are the physical devices, whereas ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Sites'
	                ),
	                ' are the places they are deployed. You\'re free to move ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Sensors'
	                ),
	                ' between ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Sites'
	                ),
	                ' to suit your operational needs.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md order-md-1' },
	            _react2.default.createElement('img', { src: _addSite2.default, className: 'img-fluid rounded', alt: 'Wintersense sensor' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'mt-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row align-items-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Share with others'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-justify' },
	              'You\'ll soon find that other colleagues, clients and collaborators are interested in your network\'s data. It\'s easy to grant them access.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Here\'s how:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Send email invitations inviting others to your ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Network'
	                ),
	                '.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'You have control over the level of access granted to each ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'User'
	                ),
	                ', from view-only through to full admin rights.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'You can even share individual ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Sites'
	                ),
	                ', for example if part of your network overlaps with another.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Export Wintersense data in ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'csv'
	                ),
	                ' format for offline analysis.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md' },
	            _react2.default.createElement('img', { src: _invite2.default, className: 'img-fluid rounded', alt: 'Wintersense sensor' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'mt-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row align-items-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md order-md-2' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Data you can trust'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-justify' },
	              'As with any sensor network, quality control is a vital component to build confidence in the data.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The Wintersense platform does this as follows:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Before sensor data is saved, forwarded, or visualised, it is passed through a variety of quality control checks.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Suspect data is flagged allowing users to easily filter it out. For example, data outside of sensible climatic bounds would be flagged.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Whenever data is flagged, or a ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Site'
	                ),
	                ' becomes in active, an alert is generated so action can be taken quickly to rectify the issue.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md order-md-1' },
	            _react2.default.createElement('img', { src: _hagleyRoadLine2.default, className: 'img-fluid rounded', alt: 'Wintersense sensor' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement('br', null)
	  );
	};
	
	exports.default = ThePlatform;
	module.exports = exports['default'];

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/invite.3656d069.png";

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WinterJumbo = function (_React$Component) {
	  _inherits(WinterJumbo, _React$Component);
	
	  function WinterJumbo() {
	    _classCallCheck(this, WinterJumbo);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WinterJumbo.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: '#00BFF3',
	          padding: '15px',
	          textAlign: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'h1',
	        {
	          style: {
	            marginBottom: '0'
	          }
	        },
	        this.props.title
	      )
	    );
	  };
	
	  return WinterJumbo;
	}(_react2.default.Component);
	
	// Prop types are a feature for runtime validation of props during development.
	
	
	WinterJumbo.propTypes = {
	  title: _propTypes2.default.string.isRequired
	};
	
	exports.default = WinterJumbo;
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ThePlatform = __webpack_require__(200);
	
	var _ThePlatform2 = _interopRequireDefault(_ThePlatform);
	
	var _WinterJumbo = __webpack_require__(73);
	
	var _WinterJumbo2 = _interopRequireDefault(_WinterJumbo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Platform = function Platform() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_WinterJumbo2.default, {
	      title: 'The Platform'
	    }),
	    _react2.default.createElement(_ThePlatform2.default, null)
	  );
	};
	
	exports.default = Platform;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-platform-js-3abc45d9121249a394fd.js